import { readCachedPosition, isDeviceLocationDenied } from './geo';

// Static, public-domain boundaries; coordinates are matched here, never sent to a geocoder.
// Loaded only when RoadRnr's existing nearby-events location has a recent fix.
const boxes = { GB: [-9,49,2,61], US: [-180,18,-66,72], AU: [112,-44,154,-10], NZ: [165,-48,179.99,-34] };
const datasets = {};
let lastKey, lastResult;
export function lookupRegion(features, lat, lng) {
  if (!Number.isFinite(lat) || !Number.isFinite(lng) || Math.abs(lat)>90 || Math.abs(lng)>180) return null;
  for (const [code, b, rings] of features) {
    if (lng<b[0] || lat<b[1] || lng>b[2] || lat>b[3]) continue;
    let inside = false;
    // Even/odd rule handles disconnected islands and polygon holes.
    for (const ring of rings) {
      for (let i=0,j=ring.length-1;i<ring.length;j=i++) {
        const [x,y]=ring[i], [u,v]=ring[j];
        if ((y>lat)!==(v>lat) && lng<(u-x)*(lat-y)/(v-y)+x) inside=!inside;
      }
    }
    if (inside) return code;
  }
  return null;
}
export function recentViewerPosition(pos, denied, now=Date.now()) {
  return !denied && pos && Number.isFinite(pos.lat) && Number.isFinite(pos.lng)
    && Number.isFinite(pos.timestamp) && now>=pos.timestamp && now-pos.timestamp<86400000 ? pos : null;
}
export async function getViewerRegion() {
  // Checking permission never prompts. Safari without this API uses the existing GPS error handler.
  let denied = isDeviceLocationDenied();
  try { denied = denied || (await navigator.permissions.query({name:'geolocation'})).state==='denied'; } catch { /* unsupported */ }
  const pos=recentViewerPosition(readCachedPosition(),denied);
  if (!pos) return null;
  const key=`${pos.lat}:${pos.lng}:${pos.timestamp}`;
  if (lastKey===key) return lastResult;
  const entry=Object.entries(boxes).find(([c,b])=>(c==='US'&&pos.lng>=172&&pos.lat>=50&&pos.lat<=72)||(pos.lng>=b[0]&&pos.lng<=b[2]&&pos.lat>=b[1]&&pos.lat<=b[3]));
  if (!entry) return null;
  const country=entry[0];
  if (!datasets[country]) datasets[country]=fetch(`${process.env.PUBLIC_URL || ''}/banner-boundaries/${country}.json`)
    .then(r=>{if(!r.ok)throw new Error('Boundary file unavailable');return r.json();})
    .catch(e=>{delete datasets[country];throw e;});
  try {
    const code=lookupRegion(await datasets[country],pos.lat,pos.lng);
    lastKey=key;lastResult=code?{viewer_country_code:country,viewer_region_code:code}:null;
    return lastResult;
  } catch { return null; }
}
